class Wishlist {
    constructor() {
        this.wishlistKey = 'shopify-wishlist';
        this.items = this.getWishlist();
        this.setupEventListeners();
        this.updateWishlistUI();
        this.setupNotification();
    }

    getWishlist() {
        const wishlist = localStorage.getItem(this.wishlistKey);
        return wishlist ? JSON.parse(wishlist) : [];
    }

    saveWishlist() {
        localStorage.setItem(this.wishlistKey, JSON.stringify(this.items));
        this.updateWishlistUI();

        // Disparar evento personalizado cuando se actualiza la wishlist
        this.dispatchWishlistEvent('save');
    }

    addItem(productId, productHandle) {
        if (!this.items.some(item => item.id === productId)) {
            this.items.push({
                id: productId,
                handle: productHandle
            });
            this.saveWishlist();

            // Mostrar notificación de producto agregado
            this.showNotification('success', 'Producto añadido a favoritos');

            // Disparar evento específico para adición de productos
            this.dispatchWishlistEvent('add', { productId, productHandle });
            return true;
        }
        return false;
    }

    removeItem(productId) {
        if (this.isInWishlist(productId)) {
            const removedItem = this.items.find(item => item.id === productId);
            this.items = this.items.filter(item => item.id !== productId);
            this.saveWishlist();

            // Mostrar notificación de producto eliminado
            this.showNotification('remove', 'Producto eliminado de favoritos');

            // Disparar evento específico para eliminación de productos
            this.dispatchWishlistEvent('remove', { productId, productHandle: removedItem?.handle });
            return true;
        }
        return false;
    }

    isInWishlist(productId) {
        return this.items.some(item => item.id === productId);
    }

    updateWishlistUI() {
        // Actualizar contador en el icono de wishlist en el header
        this.updateWishlistCount();

        // Actualizar todos los botones de wishlist en la página
        this.updateWishlistButtons();
    }

    updateWishlistCount() {
        // Actualizar contador en el icono de wishlist en el header
        const countBubble = document.querySelector('.wishlist-count-bubble');
        if (countBubble) {
            if (this.items.length > 0) {
                countBubble.classList.remove('hidden');
                const count = countBubble.querySelector('span[aria-hidden="true"]');
                if (count) {
                    count.textContent = this.items.length < 100 ? this.items.length : '99+';
                }

                // Actualizar el texto para lectores de pantalla
                const srCount = countBubble.querySelector('span.visually-hidden');
                if (srCount) {
                    srCount.textContent = `${this.items.length} artículos en la lista de deseos`;
                }
            } else {
                countBubble.classList.add('hidden');
            }
        }
    }

    updateWishlistButtons() {
        // Actualizar botones en las tarjetas de productos y en la PDP
        const productButtons = document.querySelectorAll('.wishlist-button');
        productButtons.forEach(button => {
            const productId = button.dataset.productId;
            const isInWishlist = this.isInWishlist(productId);

            // Actualizar estado del botón
            if (isInWishlist) {
                button.classList.add('is-active');
                button.setAttribute('aria-pressed', 'true');
            } else {
                button.classList.remove('is-active');
                button.setAttribute('aria-pressed', 'false');
            }

            // Actualizar texto si es el botón en la PDP (tiene elemento de texto)
            const buttonTextElement = button.querySelector('.button-text');
            if (buttonTextElement) {
                buttonTextElement.textContent = isInWishlist ? 'Eliminar de favoritos' : 'Añadir a favoritos';
            }
        });
    }

    setupNotification() {
        // Crear el elemento de notificación si no existe
        if (!document.querySelector('.wishlist-notification')) {
            const notification = document.createElement('div');
            notification.className = 'wishlist-notification';
            notification.innerHTML = `
        <span class="notification-icon">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" stroke="#e31b23" fill="#e31b23" stroke-width="2"></path>
          </svg>
        </span>
        <span class="notification-message"></span>
      `;
            document.body.appendChild(notification);
            this.notification = notification;
        } else {
            this.notification = document.querySelector('.wishlist-notification');
        }
    }

    showNotification(type, message) {
        // Actualizar el mensaje y tipo de notificación
        if (!this.notification) {
            this.setupNotification();
        }

        this.notification.querySelector('.notification-message').textContent = message;
        this.notification.className = 'wishlist-notification';
        this.notification.classList.add(type);

        // Mostrar la notificación
        setTimeout(() => {
            this.notification.classList.add('active');
        }, 10);

        // Ocultar la notificación después de 2 segundos
        setTimeout(() => {
            this.notification.classList.remove('active');
        }, 2000);
    }

    // Método para disparar eventos personalizados de wishlist
    dispatchWishlistEvent(action, detail = {}) {
        const eventDetail = {
            action: action,
            items: this.items,
            ...detail
        };

        // Crear y disparar evento personalizado
        const event = new CustomEvent('wishlist:updated', {
            bubbles: true,
            detail: eventDetail
        });

        document.dispatchEvent(event);
    }

    setupEventListeners() {
        // Usar delegación de eventos para manejar clics en botones de wishlist
        document.addEventListener('click', (event) => {
            // Buscar si el clic fue en un botón de wishlist o dentro de él
            const wishlistButton = event.target.closest('.wishlist-button');
            if (!wishlistButton) return; // Si no se hizo clic en un botón de wishlist, salir

            // Evitar comportamiento predeterminado (como navegación)
            event.preventDefault();
            event.stopPropagation();

            const productId = wishlistButton.dataset.productId;
            const productHandle = wishlistButton.dataset.productHandle;


            if (this.isInWishlist(productId)) {
                this.removeItem(productId);
            } else {
                this.addItem(productId, productHandle);
            }
        }, true); // Usar captura para asegurar que este manejador se ejecute primero
    }
}

// Inicializar la wishlist cuando el DOM esté cargado
document.addEventListener('DOMContentLoaded', () => {
    window.wishlist = new Wishlist();
});